module.exports = __webpack_public_path__ + "static/management-background-a32e966faec31298e0826449f607c2cd.jpg";